import { render } from "./PageNumbers.vue?vue&type=template&id=5e3af102"
import script from "./PageNumbers.vue?vue&type=script&lang=js"
export * from "./PageNumbers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__